exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/app/not-found/not-found.component.scss
// module id = ../../../../../src/app/not-found/not-found.component.scss
// module chunks = main